import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import MarketingLayout from "@/components/MarketingLayout";
import { useSeo } from "@/lib/seo";

const PARAS = [
  "Sisterhood+ was created to give women space to pause, reflect, and make their emotional well-being a priority.",
  "Inclusive of all women and created with women of color in mind, Sisterhood+ recognizes that our experiences, identities, and responsibilities shape how we care for ourselves—and the support we seek.",
  "Our mission is to make everyday emotional wellness more accessible and relevant through tools for journaling, self-reflection, emotional check-ins, and learning. Whether you're navigating change, carrying a lot, or simply making more room for yourself, Sisterhood+ offers a place to begin.",
  "Sisterhood+ is a digital wellness offering from Renewing Minds Counseling and Consulting Services. It provides tools for education and personal reflection; it does not replace therapy, diagnosis, or professional treatment.",
];

export default function About() {
  const navigate = useNavigate();
  useSeo({
    title: "About Sisterhood+ | Women's Emotional Wellness App",
    description:
      "Sisterhood+ is a women's emotional wellness app — inclusive of all women and created with women of color in mind. Learn about our mission and how we support everyday wellbeing.",
    path: "/about",
  });

  return (
    <MarketingLayout>
      <section className="max-w-[820px] mx-auto px-6 pt-6 pb-20">
        <p className="text-xs uppercase tracking-[0.24em] text-[#C89B55] font-semibold mb-4">About</p>
        <h1 className="font-heading text-4xl sm:text-5xl tracking-tight font-light leading-[1.08]">Made with us in mind.</h1>

        <div className="mt-8 space-y-5">
          {PARAS.map((p, i) => (
            <p key={i} className="text-[17px] text-[#291B2D]/75 leading-[1.8]">{p}</p>
          ))}
        </div>

        <div className="mt-10 bg-[#291B2D] text-white rounded-3xl p-10 text-center">
          <p className="font-heading text-3xl font-light text-[#C89B55]">You deserve room to become.</p>
          <p className="mt-3 text-white/70">Sisterhood+. Made with us in mind.</p>
        </div>

        <div className="mt-10 bg-white rounded-3xl p-7 card-soft">
          <h2 className="font-heading text-xl mb-2">Wellness support, not therapy</h2>
          <p className="text-[15px] text-[#291B2D]/75 leading-[1.75]">
            Sisterhood+ offers tools for education and personal reflection. It is not a substitute for therapy, diagnosis, medical care, or crisis services. If you are in crisis, call or text{" "}
            <a href="tel:988" className="text-[#291B2D] underline">988</a> (US). Looking for a provider? Browse our{" "}
            <Link to="/therapists" className="text-[#291B2D] underline">Find a Therapist directory</Link>.
          </p>
        </div>

        <button onClick={() => navigate("/get-started")} data-testid="about-cta"
          className="mt-10 inline-flex items-center gap-2 bg-[#291B2D] text-white rounded-full px-7 py-3.5 font-medium hover:bg-[#352238] transition-smooth">
          Start your 7-day free trial <ArrowRight size={16} />
        </button>
      </section>
    </MarketingLayout>
  );
}
